module.exports = __webpack_public_path__ + "img/logo.e0f99871.png";